var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_26449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8C14.4092 8.00191 12.8842 8.67682 11.7593 9.87667C10.6345 11.0765 10.0018 12.7033 10 14.4002C10 17.0042 11.7723 19.1667 13.6495 21.4556C14.2435 22.1804 14.8585 22.93 15.406 23.6884C15.4761 23.7854 15.566 23.8639 15.669 23.9179C15.772 23.9719 15.8852 24 16 24C16.1148 24 16.228 23.9719 16.331 23.9179C16.434 23.8639 16.5239 23.7854 16.594 23.6884C17.1415 22.93 17.7565 22.1804 18.3505 21.4556C20.2277 19.1667 22 17.0042 22 14.4002C21.9982 12.7033 21.3655 11.0765 20.2407 9.87667C19.1158 8.67682 17.5908 8.00191 16 8V8ZM16 16.8002C15.555 16.8002 15.12 16.6595 14.75 16.3957C14.38 16.132 14.0916 15.7572 13.9213 15.3186C13.751 14.8801 13.7064 14.3975 13.7932 13.9319C13.88 13.4664 14.0943 13.0387 14.409 12.7031C14.7237 12.3674 15.1246 12.1388 15.561 12.0462C15.9975 11.9536 16.4499 12.0011 16.861 12.1828C17.2722 12.3645 17.6236 12.6721 17.8708 13.0668C18.118 13.4615 18.25 13.9255 18.25 14.4002C18.25 15.0367 18.0129 15.6472 17.591 16.0973C17.169 16.5474 16.5967 16.8002 16 16.8002Z",
    fill: "url(#paint0_linear_201_26449)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_26449",
    x1: 10.075,
    y1: 8.32813,
    x2: 25.8562,
    y2: 14.3892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181818"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_26449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.dad3ccdd23b2574adb0c48f3c0dbe5b6.svg";
export { ForwardRef as ReactComponent };